var NGT = (function () {
    let subscribeList = [];
    let subscribeMap = {};
    let iframe;
    let gameBaseURL;

    function subscribe() {
        if (typeof arguments[0] == "string") {
            if (!subscribeMap[arguments[0]]) subscribeMap[arguments[0]] = [];
            subscribeMap[arguments[0]].push(arguments[1]);
        } else {
            subscribeList.push(arguments[0]);
        }
    }

    function unsubscribe() {
        if (typeof arguments[0] == "string") {
            if (arguments.length == 1) {
                delete subscribeMap[arguments[0]];
            } else {
                for (var i = subscribeMap[arguments[0]].length - 1; i > -1; i--) {
                    if (subscribeMap[arguments[0]][i].callback == arguments[1]) {
                        subscribeMap[arguments[0]].splice(i, 1);
                    }
                }
            }
        } else {
            for (let index = subscribeList.length - 1; index > -1; index--) {
                if (subscribeList[index].callback == arguments[0]) {
                    subscribeList.splice(index, 1);
                }
            }
        }
    }

    function send(data) {
        iframe.contentWindow.postMessage(data, gameBaseURL);
    }

    function create(view, url, settings) {
        subscribe("required:reload", function () {
            window.top.location.reload(true);
        });
        
        if (settings.homeURL)
            subscribe("action:home", function () {
                window.top.location.href = settings.homeURL;
            });

        if (document.readyState === "complete" || document.readyState === "interactive") {
            ready(view, url, settings)
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                ready(view, url, settings)
            })
        }

        subscribe("action:navigate", function (data) {
            window.top.location.href = data.url;
        });

    }

    function ready(view, url, settings) {

        let dom;

        gameBaseURL = url;
        const replace = {
            id: "game",
            longToken: "o_lt",
            lang: "lang_label",
            currency: "currency_label",
        }
        if (!view) {
            iframe = createIFrame();
            dom = document;
        } else if (typeof view == "string") {
            let element = document.querySelector(view);
            if (element.tagName.toLocaleLowerCase() == "iframe") {
                iframe = element;
            } else {
                iframe = createIFrame();
                dom = element;
            }
        } else
            iframe = view;

        if (dom) {
            dom.appendChild(iframe);
        }

        window.addEventListener("message", function (e) {
            if (gameBaseURL && gameBaseURL.search(e.origin) == -1) return;

            for (let i = 0; i < subscribeList.length; i++) {
                subscribeList[i](e.data.action, e.data.detail);
            }

            if (subscribeMap[e.data.action]) {
                for (let j = 0; j < subscribeMap[e.data.action].length; j++) {
                    subscribeMap[e.data.action][j](e.data.detail);
                }
            }

            if (e.data.action) send({ command: "received", action: e.data.action });

        }, false);

        iframe.src = convertURL(settings, replace);

        function convertURL(data, replace) {
            let str = "";
            for (let k in data) {
                let val = data[k];
                if (k in replace) k = replace[k]
                if (k == "lang_label" && Array.isArray(val)) val = val.pop();
                str += k + "=" + encodeURIComponent(val) + "&";

            }
            str += "origin=" + encodeURIComponent(location.origin);
            return gameBaseURL + "?" + str;
        }

        function createIFrame() {
            let iframe = document.createElement("iframe");
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.style.border = "none";
            return iframe;
        }
    }

    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        send: send,
        create: create
    }
})();

export default NGT;
